// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedContoller_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.874 5H32V7H26.874C26.4299 8.72523 24.8638 10 23 10 21.1362 10 19.5701 8.72523 19.126 7H0V5H19.126C19.5701 3.27477 21.1362 2 23 2 24.8638 2 26.4299 3.27477 26.874 5ZM23 8C24.1046 8 25 7.10457 25 6 25 4.89543 24.1046 4 23 4 21.8954 4 21 4.89543 21 6 21 7.10457 21.8954 8 23 8ZM0 15H5.12602C5.57006 13.2748 7.13616 12 9 12 10.8638 12 12.4299 13.2748 12.874 15H32V17H12.874C12.4299 18.7252 10.8638 20 9 20 7.13616 20 5.57006 18.7252 5.12602 17H0V15ZM11 16C11 17.1046 10.1046 18 9 18 7.89543 18 7 17.1046 7 16 7 14.8954 7.89543 14 9 14 10.1046 14 11 14.8954 11 16ZM32 25H26.874C26.4299 23.2748 24.8638 22 23 22 21.1362 22 19.5701 23.2748 19.126 25H0V27H19.126C19.5701 28.7252 21.1362 30 23 30 24.8638 30 26.4299 28.7252 26.874 27H32V25ZM23 28C24.1046 28 25 27.1046 25 26 25 24.8954 24.1046 24 23 24 21.8954 24 21 24.8954 21 26 21 27.1046 21.8954 28 23 28Z" class="svg-bg"/>
</svg>
`;
const _s40IconSvg = html `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.9 7H40V9H33.9C33.4367 11.2822 31.419 13 29 13 26.581 13 24.5633 11.2822 24.1 9H0V7H24.1C24.5633 4.71776 26.581 3 29 3 31.419 3 33.4367 4.71776 33.9 7ZM29 11C30.6569 11 32 9.65685 32 8 32 6.34315 30.6569 5 29 5 27.3431 5 26 6.34315 26 8 26 9.65685 27.3431 11 29 11ZM0 19H6.10002C6.56329 16.7178 8.58104 15 11 15 13.419 15 15.4367 16.7178 15.9 19H40V21H15.9C15.4367 23.2822 13.419 25 11 25 8.58104 25 6.56329 23.2822 6.10002 21H0V19ZM11 23C12.6569 23 14 21.6569 14 20 14 18.3431 12.6569 17 11 17 9.34315 17 8 18.3431 8 20 8 21.6569 9.34315 23 11 23ZM40 31H33.9C33.4367 28.7178 31.419 27 29 27 26.581 27 24.5633 28.7178 24.1 31H0V33H24.1C24.5633 35.2822 26.581 37 29 37 31.419 37 33.4367 35.2822 33.9 33H40V31ZM32 32C32 33.6569 30.6569 35 29 35 27.3431 35 26 33.6569 26 32 26 30.3431 27.3431 29 29 29 30.6569 29 32 30.3431 32 32Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedContoller is a generated icon component.
 */
let IconMedContoller = IconMedContoller_1 = class IconMedContoller extends IconBaseElement {
    render() {
        return html `${IconMedContoller_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedContoller.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s40IconSvg],
    ['s48', _s40IconSvg],
    ['s64', _s40IconSvg],
    ['s72', _s40IconSvg],
    ['s80', _s40IconSvg],
]);
IconMedContoller = IconMedContoller_1 = __decorate([
    customElement('zui-icon-med-contoller')
], IconMedContoller);
export { IconMedContoller };
